// Metų žemėlapis paslėptas iki launch. Kai ao sako „paleidžiam" — METU_ZEMELAPIS_LIVE = true.
// Peržiūrai: atidaryk bet kurį puslapį su ?preview=metai (įsimena šiame įrenginyje), ?preview=off — išjungia.
export const METU_ZEMELAPIS_LIVE = false;

export function metuZemelapisVisible(): boolean {
  if (METU_ZEMELAPIS_LIVE) return true;
  if (typeof window === "undefined") return false;
  try {
    const p = new URLSearchParams(window.location.search).get("preview");
    if (p === "metai") window.localStorage.setItem("mz_preview", "1");
    if (p === "off") window.localStorage.removeItem("mz_preview");
    return window.localStorage.getItem("mz_preview") === "1";
  } catch {
    return false;
  }
}
